import React, { useEffect, useState } from 'react';
import "./SpecialistsList.scss";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSpecialistsAction } from '../../../store/scheduleReducer';
import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';

const SpecialistsList = ({ specialists: initialSpecialists = [] }) => {
    const dispatch = useDispatch();
    const [localSpecialists, setLocalSpecialists] = useState(
        initialSpecialists.map((s, i) => ({ ...s, orderIndex: i }))
    );

    const currentUser = useSelector(state => state.currentUser.currentUser)

    useEffect(() => {
        setLocalSpecialists(initialSpecialists.map((s, i) => ({ ...s, orderIndex: i })));
    }, [initialSpecialists]);

    const sortDown = (index) => {
        if (index < localSpecialists.length - 1) {
            const updatedList = [...localSpecialists];
            const [moved] = updatedList.splice(index, 1);
            updatedList.splice(index + 1, 0, moved);

            const orderedList = updatedList.map((s, i) => ({ ...s, orderIndex: i }));

            setLocalSpecialists(orderedList);
            dispatch(setSpecialistsAction(orderedList));

            fetchSortSpeciaslist(updatedList.map((specialist) => Number(specialist.id)));
        }
    };

    const sortUp = (index) => {
        if (index > 0) {
            const updatedList = [...localSpecialists];
            const [moved] = updatedList.splice(index, 1);
            updatedList.splice(index - 1, 0, moved);

            const orderedList = updatedList.map((s, i) => ({ ...s, orderIndex: i }));

            setLocalSpecialists(orderedList);
            dispatch(setSpecialistsAction(orderedList));

            fetchSortSpeciaslist(updatedList.map((specialist) => Number(specialist.id)));
        }
    };

    const [fetchSortSpeciaslist] = useFetching(async (ids) => {
        const response = await PostService.sortSpeciaslist(ids);

        if (response.data.success && response.data.result !== false) {
        }
    })

    return (
        <div className="specialists-list">
            {localSpecialists.map((specialist, index) => {
                const mainPosition = specialist.position_id ? specialist.positions[specialist.position_id[0]] : null
                return (
                    <div className="specialists-list__item" key={specialist.id}>
                        <div className="specialists-list__item-count">{specialist.orderIndex + 1}</div>
                        <div className="specialists-list__item-block">
                            <div className="specialists-list__item-text">
                                <div className="specialists-list__item-name">
                                    {specialist.name}<span>,</span>
                                </div>
                                <div className="specialists-list__item-position">
                                    {!!mainPosition ? mainPosition.name : 'Сотрудник'}
                                </div>
                            </div>
                            <div className='specialists-list__item-edit-block'>
                                <div className="specialists-list__item-arrows">
                                    <div
                                        className={`specialists-list__item-arrow specialists-list__item-arrows-up ${index === 0 ? 'disabled' : ''}`}
                                        onClick={() => index !== 0 && sortUp(index)}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.00075 2.92262L4.10968 6.81024M8.00075 2.92262L11.8888 6.81068M8.00075 2.92262L8.00075 13.079"
                                                stroke="#949594" strokeWidth="1.25" strokeLinecap="round"
                                                strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div
                                        className={`specialists-list__item-arrow specialists-list__item-arrows-down ${index === localSpecialists.length - 1 ? 'disabled' : ''}`}
                                        onClick={() => index !== localSpecialists.length - 1 && sortDown(index)}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.00075 13.0774L4.10968 9.18976M8.00075 13.0774L11.8888 9.18932M8.00075 13.0774L8.00075 2.92102"
                                                stroke="#949594" strokeWidth="1.25" strokeLinecap="round"
                                                strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <Link className="specialists-list__item-edit"
                                    to={`/schedule/specialist/${specialist.id}/`}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.99794 3.52173L8.81274 1.70706C9.20327 1.31656 9.83642 1.31657 10.2269 1.70709L12.7928 4.273C13.1833 4.66354 13.1833 5.29672 12.7928 5.68723L10.9781 7.5018M6.99794 3.52173L1.96604 8.55359C1.81615 8.70347 1.71777 8.8971 1.6851 9.10654L1.21075 12.1467C1.10632 12.816 1.6836 13.3933 2.35294 13.2889L5.39321 12.8146C5.60265 12.7819 5.79629 12.6835 5.94618 12.5336L10.9781 7.5018M6.99794 3.52173L10.9781 7.5018"
                                            stroke="#949594" strokeWidth="1.25" strokeLinecap="round"
                                            strokeLinejoin="round" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default SpecialistsList;